import React from 'react'
import { string } from 'prop-types'

import NotInstallableButton from './NotInstallableButton'

const EmptyApp = ({ id, ...props }) => (
  <NotInstallableButton {...props}>
    <span>
      You cannot install an empty app. If there are no Building Blocks
      specified, the installation won't make any effect or sense. Set up some
      Building Blocks in{' '}
      <a
        href={`${process.env.GATSBY_CONSOLE_URL}/apps/${id}/blocks`}
        target="_blank"
        rel="noopener noreferrer"
        className="link"
      >
        Developer Console
      </a>{' '}
      now!
    </span>
  </NotInstallableButton>
)

EmptyApp.propTypes = {
  id: string,
}

export default EmptyApp
